import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { paymentRecordTypeTextMap, paymentTypeInfoMap } from 'libs/uikit/src/constants';
import { QuoteBillPaymentStatusEnum } from 'libs/uikit/src/shared/generated';
import { formatCommonDateStr } from 'libs/uikit/src/utils/time';
import { cloneDeep, orderBy } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PolicyPaymentScheduleWithUnConfirmView = function PolicyPaymentScheduleWithUnConfirmView(props) {
  var scheduleList = props.scheduleList,
      unconfirmList = props.unconfirmList,
      className = props.className,
      onlyDisplayPendingPayment = props.onlyDisplayPendingPayment,
      valueChange = props.valueChange;

  var _useState = useState([]),
      dataList = _useState[0],
      setDataList = _useState[1];

  useEffect(function () {
    // Schedule
    var list1 = (scheduleList || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        paymentTypeText: paymentTypeInfoMap.payment.label,
        type: paymentRecordTypeTextMap.schedule.value
      });
    });

    if (onlyDisplayPendingPayment) {
      list1 = list1.filter(function (item) {
        return item.payment_status === QuoteBillPaymentStatusEnum.PENDING;
      });
    } // Unconfirmed


    var list2 = (unconfirmList || []).map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        type: paymentRecordTypeTextMap.adjustment.value
      });
    });

    var isEmptyDate = function isEmptyDate(date) {
      return !date || (date === null || date === void 0 ? void 0 : date.trim()) === '';
    };

    setDataList(orderBy([].concat(_toConsumableArray(list1), _toConsumableArray(list2)), [function (item) {
      return isEmptyDate(item.statement_date) ? Infinity : dayjs(item.statement_date).valueOf();
    }, ['desc']]));
  }, [scheduleList, unconfirmList]);
  useEffect(function () {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(cloneDeep(dataList));
  }, [dataList]);
  return (dataList === null || dataList === void 0 ? void 0 : dataList.length) > 0 ? /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', className),
    children: /*#__PURE__*/_jsxs(Table, {
      size: "small",
      children: [/*#__PURE__*/_jsx(TableHead, {
        children: /*#__PURE__*/_jsxs(TableRow, {
          children: [/*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: "Type"
          }), /*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: "Deduction time"
          }), /*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: "Payment activity"
          }), /*#__PURE__*/_jsx(TableCell, {
            className: "bg-gray-100",
            padding: "none",
            align: "center",
            children: "Total"
          })]
        })
      }), /*#__PURE__*/_jsx(TableBody, {
        children: dataList.map(function (row, index) {
          var _paymentRecordTypeTex;

          var textStyles = row.type === paymentRecordTypeTextMap.adjustment.value ? {
            color: '#0E35D1'
          } : undefined;
          return /*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              align: "center",
              sx: textStyles,
              children: (_paymentRecordTypeTex = paymentRecordTypeTextMap[row.type]) === null || _paymentRecordTypeTex === void 0 ? void 0 : _paymentRecordTypeTex.label
            }), /*#__PURE__*/_jsx(TableCell, {
              align: "center",
              sx: textStyles,
              children: formatCommonDateStr(row.statement_date)
            }), /*#__PURE__*/_jsx(TableCell, {
              align: "center",
              sx: textStyles,
              children: row.paymentTypeText
            }), /*#__PURE__*/_jsx(TableCell, {
              align: "center",
              sx: textStyles,
              children: row.totalText
            })]
          }, index);
        })
      })]
    })
  }) : null;
};

export default PolicyPaymentScheduleWithUnConfirmView;